import React from 'react';
import FacturePositionTool from '../components/FacturePositionTool';

const FactureTool: React.FC = () => {
  const pdfOptions = {
    'Facture.pdf': {
      url: '/pdfs/facture.pdf', // Mettez ici le chemin correct de votre PDF de facture
      fields: {}, // Les champs sont définis dans FacturePositionTool, mais cette structure est nécessaire
      firestoreDoc: 'maFacture', // <-- Modifié à 'maFacture'
    },
  };

  // Vous devrez peut-être passer le nom par défaut si nécessaire
  const defaultPdfName = 'Facture.pdf'; 

  return (
    <FacturePositionTool pdfOptions={pdfOptions} defaultPdfName={defaultPdfName} />
  );
};

export default FactureTool;

export {}; 